export default class AdminCalls {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  dial(consultation_id, payload = {}) {
    return this.axiosIns.post(`/call/${consultation_id}/dial-video`, payload)
  }
}
